import * as Sentry from '@sentry/react';
import { reactRouterV6Instrumentation } from "@sentry/react";
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

function createSentry() {
  let client: Sentry.BrowserClient | undefined;
  const wrapped = {
    init() {
      if (
        BUILD_CONFIG.SENTRY_DSN &&
        !client
      ) {
        // https://docs.sentry.io/platforms/javascript/guides/react/#configure
        client = Sentry.init({
          dsn: BUILD_CONFIG.SENTRY_DSN,
          debug: BUILD_CONFIG.debug ?? false,
          environment: BUILD_CONFIG.appBuildType,
          integrations: (defaults) => [
            ...defaults,
            Sentry.browserTracingIntegration({}),
            Sentry.browserProfilingIntegration(),
            // Sentry.replayIntegration({
            //   maskAllText: false,
            //   blockAllMedia: false,
            //   networkDetailAllowUrls: [
            //     "https://api.muset.ai",
            //     "https://api-va.muset.ai",
            //     "wss://api-va.muset.ai",
            //   ],
            // }),
          ],
          // replaysSessionSampleRate: 0,
          // 性能追踪采样率
          tracesSampleRate: 0.1, // 生产环境 10%
          // 性能分析采样率
          profilesSampleRate: 0.1, // 生产环境 10%
          sendDefaultPii: true,
          // 控制哪些 URL 启用追踪
          tracePropagationTargets: [
            'localhost',
            /^https:\/\/.*\.wenxiaobai\.com/,
            /^https:\/\/.*\.muset\.ai/,
          ],
        }) as Sentry.BrowserClient;

        Sentry.setTags({
          distribution: BUILD_CONFIG.distribution,
          appVersion: BUILD_CONFIG.appVersion,
          editorVersion: BUILD_CONFIG.editorVersion,
        });
      }
    },
    enable() {
      if (client) {
        client.getOptions().enabled = true;
      }
    },
    disable() {
      if (client) {
        client.getOptions().enabled = false;
      }
    },
  };

  return wrapped;
}

export const sentry = createSentry();
